// Stránky investičních bytů – kalendář pole „Preferovaný termín prohlídky“ ve formuláři projektu.
// Pole je datum Fluent Forms (flatpickr); vzhled a chování podle vlastního výběru data ze statiky
// apartmanyjeseniky.cz (js/datepicker.js): šipky měsíců v rámečku, ikona kalendáře v poli, patička
// „Dnes / Vymazat“, termín dnes až za 12 měsíců. Češtinu, formát „26. 9. 2026“ a zákaz minulých dnů
// nastavuje PHP (efi_rd_reality_form_date() v includes/redesign/reality-form.php), styly
// assets/scss/reality/_datepicker.scss.
//
// Fluent Forms zakládá kalendář až ve svém skriptu v patičce (jQuery ready) a na konci zavolá
// `onReady` → window.efiRdDatepicker. Funkce se proto registruje hned při načtení bundlu, ne až
// po DOMContentLoaded; initRealityDatepicker() pak jen dorovná kalendáře založené dřív.

const MONTHS_AHEAD = 12;
const SVG = (paths) =>
  `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${paths.map((d) => `<path d="${d}"/>`).join('')}</svg>`;
const ICON_CALENDAR = SVG(['M4 5h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z', 'M3 10h18', 'M8 3v4', 'M16 3v4']);
const ICON_PREV = SVG(['m14 6-6 6 6 6']);
const ICON_NEXT = SVG(['m10 6 6 6-6 6']);

function button(label, className) {
  const el = document.createElement('button');
  el.type = 'button';
  el.className = className;
  el.textContent = label;

  return el;
}

function enhance(fp) {
  if (!fp || !fp.calendarContainer || fp.calendarContainer.classList.contains('re-dp')) {
    return;
  }

  const cal = fp.calendarContainer;
  const input = fp.altInput || fp.input;
  cal.classList.add('re-dp');

  const max = new Date();
  max.setMonth(max.getMonth() + MONTHS_AHEAD);
  fp.set('maxDate', max);

  // šipky měsíců jako ve vzoru (flatpickr má vlastní ikonu)
  [[fp.prevMonthNav, ICON_PREV, 'Předchozí měsíc'], [fp.nextMonthNav, ICON_NEXT, 'Následující měsíc']].forEach(([nav, icon, label]) => {
    if (nav) {
      nav.innerHTML = icon;
      nav.setAttribute('aria-label', label);
    }
  });

  const foot = document.createElement('div');
  foot.className = 're-dp__foot';
  const today = button('Dnes', 're-dp__action');
  const clear = button('Vymazat', 're-dp__action re-dp__action--ghost');
  today.addEventListener('click', () => {
    fp.setDate(new Date(), true);
    fp.close();
  });
  clear.addEventListener('click', () => {
    fp.clear();
    fp.close();
  });
  foot.append(today, clear);
  cal.appendChild(foot);

  // viditelné pole (altInput) dostane popisek pole a ikonu kalendáře; původní pole je skryté
  if (fp.altInput) {
    fp.altInput.id = `${fp.input.id}-zobrazeni`;
    const label = fp.input.id ? document.querySelector(`label[for="${fp.input.id}"]`) : null;
    if (label) {
      label.setAttribute('for', fp.altInput.id);
    }
    if (fp.input.getAttribute('aria-label')) {
      fp.altInput.setAttribute('aria-label', fp.input.getAttribute('aria-label'));
    }
  }

  const toggle = button('', 're-dp-toggle');
  toggle.innerHTML = ICON_CALENDAR;
  toggle.setAttribute('aria-label', 'Otevřít kalendář');
  // klik mimo kalendář ho flatpickr zavře už při mousedown – bez zapamatování by ho klik hned znovu otevřel
  let wasOpen = false;
  toggle.addEventListener('mousedown', () => {
    wasOpen = fp.isOpen;
  });
  toggle.addEventListener('click', () => {
    if (!wasOpen) {
      fp.open();
    }
    wasOpen = false;
  });
  // obal jen kolem pole a ikony – chybová hláška Fluent Forms pod polem pak ikonu nenatáhne
  const wrap = document.createElement('span');
  wrap.className = 're-dp-field';
  input.before(wrap);
  wrap.append(input, toggle);

  // panel široký jako pole, nejméně 272 px (sedm sloupců dnů pohodlně na klik), v okně
  fp.config.onPreCalendarPosition.push(() => {
    const width = Math.max(input.offsetWidth, 272);
    cal.style.width = `${Math.min(width, window.innerWidth - 16)}px`;
  });
}

window.efiRdDatepicker = enhance;

export default function initRealityDatepicker() {
  document.querySelectorAll('.ff-el-datepicker').forEach((input) => {
    if (input._flatpickr) {
      enhance(input._flatpickr);
    }
  });
}
